import api from "../utils/axios/axiosConfig";

const creditAccountsService = {
  create: (data) => api.post("/credit-accounts/create", data),

  update: (id, data) => api.put(`/credit-accounts/update/${id}`, data),

  delete: (id) => api.delete(`/credit-accounts/delete/${id}`),

  get: (id) => api.get(`/credit-accounts/get/${id}`),

  search: (params) => api.post("/credit-accounts/search", params),

  searchAccounts: (id) =>
    api.get(`/credit-accounts/search_accounts${id ? `/${id}` : ""}`),

  getUserAccount: (data) => api.post("/credit-accounts/get-user-account", data),

  // Payments
  createStripePayment: (data) =>
    api.post("/credit-accounts/create-stripe-payment", data),

  processStripePayment: (data) =>
    api.post("/credit-accounts/process-stripe-payment", data),

  processPayPalPayment: (data) =>
    api.post("/credit-accounts/process-paypal-payment", data),

  processBankTransferPayment: (data) =>
    api.post("/credit-accounts/process-bank-transfer-payment", data),

  processPayoneerPayment: (data) =>
    api.post("/credit-accounts/process-payoneer-payment", data),

  processCryptoPayment: (data) =>
    api.post("/credit-accounts/process-crypto-payment", data),

  processWithdraw: (data) =>
    api.post("/credit-accounts/process-withdraw", data),

  keepAccountActive: (data) =>
    api.post("/credit-accounts/keep-account-active", data),
};

export default creditAccountsService;
